import React from 'react';
import { FaUsers, FaRocket, FaChartLine, FaCog, FaAward, FaBuilding } from 'react-icons/fa';
import ContactCard from '../Components/ContactCardSection';


const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-5 about-hero-section">
        <div className="container">
          <div className="row align-items-center g-4">
            {/* Icon Box Column - Left Side */}
            <div className="col-12 col-md-4 col-lg-3">
              <div className="about-hero-icon-box">
                <FaBuilding className="about-hero-icon" />
              </div>
            </div>

            {/* Text Content Column - Right Side */}
            <div className="col-12 col-md-8 col-lg-9">
              <div className="about-hero-text-content">
                <h1 className="about-hero-main-title">"Empowering businesses to operate securely and efficiently in the digital era."</h1>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Main Content Section */}
      <section className="py-2 section-alt-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="mb-5">
                <p className="fs-5 text-dark lh-lg mb-4">
                  At <strong className="text-navyblue">DeepCyber Consulting</strong>, we specialize in providing comprehensive IT and cybersecurity solutions that empower businesses to operate securely and efficiently in the digital era. Founded on a commitment to innovation and excellence, our team of certified professionals brings deep expertise in <strong>IT Strategic Planning</strong>, <strong>Software Development</strong>, <strong>Managed IT Services</strong>, and <strong>Cybersecurity</strong>.
                </p>
                
                <p className="fs-5 text-dark lh-lg mb-4">
                  We understand that every organization is unique, and we tailor our solutions to meet your specific business needs. From designing scalable IT infrastructures and optimizing workflows to implementing advanced security measures like <strong>Endpoint Detection & Response (EDR)</strong> and <strong>Vulnerability Management</strong>, we ensure your technology environment is robust, secure, and future-ready.
                </p>
                
                <p className="fs-5 text-dark lh-lg mb-4">
                  Our approach combines strategic insights, hands-on expertise, and proactive support, helping businesses not only protect their digital assets but also leverage technology for growth and operational efficiency. By fostering close collaboration with our clients, we deliver solutions that are practical, measurable, and aligned with business objectives.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-2 section-alt-bg" >
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-8 mx-auto text-center">
              <h2 className="display-6 fw-bold text-navyblue mb-3"> <FaUsers className="me-2" />Why Choose DeepCyber Consulting?</h2>
              <p className="text-muted">
                We don't just provide IT services — we enable organizations to thrive in an increasingly complex digital world.
              </p>
            </div>
          </div>

          <div className="row g-4">
            {/* Card 1 */}
            <div className="col-lg-6 col-md-6">
              <div className="card h-100 border-0 shadow-sm about-feature-card">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="feature-icon-wrapper me-3">
                      <FaChartLine className="text-navyblue" size={32} />
                    </div>
                    <h4 className="mb-0 text-navyblue">Proven Expertise</h4>
                  </div>
                  <p className="text-dark mb-0">
                    Comprehensive knowledge across IT strategy, development, and cybersecurity with certified professionals.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-lg-6 col-md-6">
              <div className="card h-100 border-0 shadow-sm about-feature-card">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="feature-icon-wrapper me-3">
                      <FaCog className="text-navyblue" size={32} />
                    </div>
                    <h4 className="mb-0 text-navyblue">Tailored Solutions</h4>
                  </div>
                  <p className="text-dark mb-0">
                    Customized solutions that scale with your business needs and adapt to your unique requirements.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-lg-6 col-md-6">
              <div className="card h-100 border-0 shadow-sm about-feature-card">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="feature-icon-wrapper me-3">
                      <FaRocket className="text-navyblue" size={32} />
                    </div>
                    <h4 className="mb-0 text-navyblue">Proactive Services</h4>
                  </div>
                  <p className="text-dark mb-0">
                    Reliable managed services designed to minimize risk and maximize productivity for your organization.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 4 */}
            <div className="col-lg-6 col-md-6">
              <div className="card h-100 border-0 shadow-sm about-feature-card">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="feature-icon-wrapper me-3">
                      <FaAward className="text-navyblue" size={32} />
                    </div>
                    <h4 className="mb-0 text-navyblue">Commitment to Excellence</h4>
                  </div>
                  <p className="text-dark mb-0">
                    Dedicated to excellence, integrity, and building long-term client partnerships that drive success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      <ContactCard/>
      </section>
    </div>
  );
};

export default About;